<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
		<el-form-item label='所属店铺'>
		   <!-- <el-input v-model='queryForm.shopId'></el-input> -->
		    <GridSelectLi style="width: 180px" title="选择店铺" labelName="shopName" labelValue="id"
		   	:value="queryForm.shopId" :limit="1" size="small"
		   	@getValue="getSeachValueShopId" :columns="SHOP_code" :searchs="SHOP_search" dataListUrl="/mall/shop/findList" entityBeanName="mallShop" queryEntityUrl="/mall/shop/get">
		   	</GridSelectLi>
		</el-form-item>
            <el-form-item label="登录账号">
                <el-input v-model="queryForm.userName" placeholder="请填写登录账号" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input v-model="queryForm.userMobile" placeholder="请填写手机号码" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="用户昵称">
                <el-input v-model="queryForm.userNickname" placeholder="请填写用户昵称" style="width: 180px"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input v-model="queryForm.userRealname" placeholder="请填写真实姓名" style="width: 180px"></el-input>
            </el-form-item>

            <el-form-item label="流水类型">
                <el-select placeholder="请选择流水类型" clearable v-model="queryForm.flowType" style="width: 180px">
                    <el-option v-for="item in flowTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
           
            <el-form-item label="操作时间">
                <el-date-picker
                    style="width: 180px"
                    v-model="timeRange"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item label="增减类型">
                <el-select placeholder="请选择增减类型" clearable v-model="queryForm.flowOrientation" style="width: 180px">
                    <el-option v-for="item in flowOrientationList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>

            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopMoneyFlowList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
			
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopMoneyFlow(null)"
                        >删除</el-button
                    >
                    <span style="margin-left: 20px; font-size: 14px;">
                        累计金额：{{ totalAmount }}
                    </span>
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span title="导出数据" class="icon-box" @click="exportShopMoneyFlowList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopMoneyFlowList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopMoneyFlowList"
                width="100%"
                row-key="id"
                size="small"
                height="100%"
                @selection-change="handleSelectionChange"
                :default-expand-all="true"
            >
                <el-table-column align="center" type="selection" width="50px"> </el-table-column>
                <el-table-column align="left" label="用户" width="150px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                            <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                            <!-- <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div> -->
                            <!-- <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div> -->
                            <!-- <div style="text-align: left">手机号：{{ scope.row.user.userMobile }}</div> -->
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="货币类型" width="100px">
                    <template slot-scope="scope">
                        {{ getCurrecyType(scope.row.flowType) }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="originalMoney" label="动账前金额" width="100px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="操作方向" width="100px">
                    <template slot-scope="scope">
                        {{ getOrientation(scope.row.flowOrientation) }}
                    </template>
                </el-table-column>
				<el-table-column :show-overflow-tooltip="true" align="center" prop="money" label="金额" width="100px"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="restMoney" label="动账后金额"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="flowDetail" label="资金流水记录描述"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="添加时间"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="100px">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="deleteShopMoneyFlow(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
				<el-table-column
				    :show-overflow-tooltip='true'
				    align='center'
				    prop='shopId'
				    label='所属店铺'
				    width='180'
				>
		     <template slot-scope="scop">
					<span v-if="scop.row.shop">{{scop.row.shop.shopName}}</span>
	                <span v-else>暂无店铺</span>
			</template>
				</el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, get, post, deleteFun } from '@/utils/request.js';
import { SHOP, SHOP_SEARCH } from '@/utils/constant';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
export default {
    components: {
		GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopMoneyFlowList();
                this.getShopMoneyFlowList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopMoneyFlowList();
                this.getShopMoneyFlowList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            timeRange: [],
            queryForm: {
				shopId:'',//店铺ID
                flowType: '', //资金类型
                flowOrientation: '', //增减类型
                userName: '',
                startTime: '',
                endTime: '',
                userMobile: '',
                userNickname: '',
                userRealname: ''
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopMoneyFlowState: 'add',
            shopMoneyFlowStates: {
                check: '查看资金流水'
            },
            flowTypeList: [], //流水类型
            flowOrientationList: [], //操作类型
            multipleSelection: [],
            shopMoneyFlowList: [],
            shopMoneyFlow: {
                id: '', //主键自增
                money: '', //资金
                originalMoney: '', //初始金额
                restMoney: '', //剩余金额
                flowDetail: '', //资金流水记录描述
                flowType: '', //资金类型
                flowOrientation: '', //增减类型
                userId: '', //用户id

                createUserId: '', //创建人
                createTime: '', //创建时间
                updateUserId: '', //更新人
                updateTime: '', //更新时间
                deleteFlag: '', //是否删除
                user: {
                    userName: ''
                }
            },
            btnLoading: false,

            rules: {},
            totalAmount: 0,
            isTrue: false,
			SHOP_code: SHOP,
			SHOP_search: SHOP_SEARCH
        };
    },
    created() {
        this.getShopMoneyFlowList();
        this.getFlowTypeList();
        this.getFlowOrientationList();
    },
    methods: {
        getCurrecyType(type) {
            for (const index in this.flowTypeList) {
                if (this.flowTypeList[index].key == type) {
                    return this.flowTypeList[index].value;
                }
            }
        },
        gettotalAmount(){
            get(`shop/subshop/moneyflow/sumMoney`, { ...this.queryForm }).then((res) => {
                if(res.success){
                    this.totalAmount = res.totalMoney;
                }
            });
        },
        getOrientation(orientation) {
            for (const index in this.flowOrientationList) {
                if (this.flowOrientationList[index].key == orientation) {
                    return this.flowOrientationList[index].value;
                }
            }
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopMoneyFlowList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopMoneyFlowList = [];
        },
        resetDialog() {
            this.shopMoneyFlowState = 'add';
            this.showDialog = false;
            this.queryForm = {
				shopId:'',//店铺ID
                flowType: '', //资金类型
                flowOrientation: '', //增减类型
                userName: '',
                startTime: '',
                endTime: '',
                 userMobile: '',
                userNickname: '',
                userRealname: ''
            };
            this.timeRange = [];
            this.getShopMoneyFlowList();
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.shopMoneyFlowState == 'add') {
                this.$refs.shopMoneyFlowForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/subshop/moneyflow/add`, { ...this.shopMoneyFlow }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopMoneyFlowList();
                                this.resetDialog();
                                this.getShopMoneyFlowList();
                            }
                        });
                    }
                });
            } else if (this.shopMoneyFlowState == 'edit') {
                this.$refs.shopMoneyFlowForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/subshop/moneyflow/edit`, { ...this.shopMoneyFlow }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopMoneyFlowList();
                                this.resetDialog();
                                this.getShopMoneyFlowList();
                            }
                        });
                    }
                });
            }
        },
        addShopMoneyFlow() {
            (this.shopMoneyFlow = {}), (this.showDialog = true);
            this.shopMoneyFlowState = 'add';
        },
        checkShopMoneyFlow(shopMoneyFlowId) {
            console.log(shopMoneyFlowId);
            this.currentShopMoneyFlowId = shopMoneyFlowId;

            this.getShopMoneyFlowById();
            this.showDialog = true;
            this.shopMoneyFlowState = 'check';
        },
        editShopMoneyFlow(shopMoneyFlowId) {
            console.log('shopMoneyFlow', shopMoneyFlowId);
            if (shopMoneyFlowId) {
                this.currentShopMoneyFlowId = shopMoneyFlowId;
                this.getShopMoneyFlowById();
            } else {
                this.shopMoneyFlow = { ...this.shopMoneyFlow, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopMoneyFlowState = 'edit';
        },
        deleteShopMoneyFlow(shopMoneyFlowId) {
            let ids = '';
            if (shopMoneyFlowId) {
                ids = shopMoneyFlowId;
            } else {
                ids = this.multipleSelection.map((shopMoneyFlow) => shopMoneyFlow.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/subshop/moneyflow/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopMoneyFlowList();
                            this.getShopMoneyFlowList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopMoneyFlowList() {
            this.isTrue = false;
            this.resetShopMoneyFlowList();
            this.getShopMoneyFlowList();
        },
        getShopMoneyFlowList() {
            this.loading = true;
            if (this.timeRange.length != null) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            }
            // console.log(this.queryForm); //return;
            get(`/shop/subshop/moneyflow/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopMoneyFlowList = res.page.list;
                    this.totalNum = res.page.total;
                }
                if(this.isTrue){
                    this.gettotalAmount();
                }else{
                    this.isTrue = true;
                }
            });
        },
        getShopMoneyFlowById() {
            get(`/shop/subshop/moneyflow/get`, { id: this.currentShopMoneyFlowId }).then((res) => {
                if (res.success) {
                    this.shopMoneyFlow = { ...this.shopMoneyFlow, ...res.shopMoneyFlow };
                }
            });
        },
        /**
         * 导出余额流水信息
         */
        exportShopMoneyFlowList() {
            // this.btnLoading = true;
            exprotExcel(`/shop/subshop/moneyflow/export`, { ...this.queryForm });
        },

        //获取操作类型
        getFlowOrientationList() {
            get(`/mpp/utils/getEnum`, { enumType: `money_flow_orientation` }).then((res) => {
                if (res.success) {
                    this.flowOrientationList = res.enumList;
                }
            });
        },
        //获取流水类型
        getFlowTypeList() {
            get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                if (res.success) {
                    this.flowTypeList = res.enumList;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopMoneyFlowList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopMoneyFlowList();
        },
		getSeachValueShopId(val){
			this.queryForm.shopId=val;
		}
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
// .moneyFlow-table-expand {
//     font-size: 0;
//     margin-top: -20px;
// }
// .moneyFlow-table-expand label {
//     width: 90px;
//     color: #99a9bf;
// }
// .moneyFlow-table-expand .el-form-item {
//      margin-left: 4%;
//      margin-bottom: -1%;
//      width: 100%;

// }
</style>
